/**
 * Pet profile runtime for the Pets pages. Keeps the shopper's dog or cat choice, pet name and
 * measurements in this browser only (localStorage key "lumi:pet"), and keeps three kinds of markup
 * in step with it:
 *   [data-pets-text="Shop for {who}"]   text filled from the profile
 *   [data-pets-filter][data-pets="dog"] hidden when it does not suit the chosen pet
 *   [data-pets-deadline="cn" | "us"]    hidden once that Christmas order-by date has passed
 * Lumi.pet.get / set / reset; every change emits "lumi:pets:changed" with { profile }.
 */
(function () {
  const Lumi = (window.Lumi = window.Lumi || {});
  if (Lumi.pet || !Lumi.petsCore) return;
  const core = Lumi.petsCore;
  const KEY = 'lumi:pet';

  function readSaved() {
    try {
      return core.parseProfile(window.localStorage.getItem(KEY));
    } catch (e) {
      return core.parseProfile(null);
    }
  }

  function save() {
    if (Lumi.storage) Lumi.storage.set(KEY, profile);
  }

  const copy = () => Object.assign({}, profile);
  let profile = core.applyUrlParams(readSaved(), new URLSearchParams(window.location.search));

  function deadlineFor(kind) {
    const s = Lumi.petsSettings || {};
    return kind === 'us' ? s.usDeadline : s.cnDeadline;
  }

  function apply(root) {
    const scope = root || document;
    const now = new Date();
    const zone = (Lumi.petsSettings && Lumi.petsSettings.timeZone) || 'America/New_York';
    scope.querySelectorAll('[data-pets-text]').forEach((el) => {
      el.textContent = core.fillTemplate(el.dataset.petsText, profile);
    });
    scope.querySelectorAll('[data-pets-filter][data-pets]').forEach((el) => {
      el.hidden = !core.fits(el.dataset.pets, profile.pet);
    });
    scope.querySelectorAll('[data-pets-deadline]').forEach((el) => {
      el.hidden = !core.isBeforeDeadline(now, deadlineFor(el.dataset.petsDeadline), zone);
    });
  }

  function commit(next) {
    profile = core.parseProfile(JSON.stringify(next));
    save();
    apply();
    if (Lumi.emit) Lumi.emit('lumi:pets:changed', { profile: copy() });
    return copy();
  }

  Lumi.pet = {
    get: copy,
    set: (patch) => commit(Object.assign({}, profile, patch || {})),
    reset: () => commit({ pet: 'all', name: '' }),
    apply,
  };

  save();
  apply();
})();
